export default "__VITE_ASSET__ChMyilgW__"